<template>
  <div>
    <slice />
    <div class="container">
        <div class="contact" v-html="content"></div>
    </div>
  </div>
</template>


<script>
import slice from '../../components/slice.vue';
import {Page} from '@/api'
export default {
  name:'contact',
  components:{
    slice
  },
  data(){
    return {
      content:''
    }
  },
  mounted(){
    this.getPage();
  },
  methods:{
    getPage(){
      var that = this;
      var postData = {page:'contact'};
      Page(postData).then(res=>{
        that.content = res.data.content
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    width: 1200px;
    margin: 0 auto;
  }
  .contact{
    padding: 50px;
    font-size: 16px;
  }
</style>